<template>
  <form id="acessoryForm" class="mx-auto col-sm-8" @submit.prevent>
    <div
      class="form-group"
      :class="{ 'has-error': errors.has('acessory') }"
    >
      <label for="acessory">{{ $t("acessory") }}</label>
      <input
        type="text"
        id="acessory"
        name="acessory"
        class="form-control"
        :placeholder="$t('ph_acessory')"
        v-model="acessory.name"
        v-validate="'required'"
        @input="acessory.name = acessory.name.toUpperCase()"
      />
      <small v-show="errors.has('acessory')" class="form-text">
        {{ errors.first("acessory") }}
      </small>
    </div>

    <div class="switch mb-3">
      <label for="isActive">{{ $t("active") }}</label>
      <div class="onoffswitch2">
        <input
          type="checkbox"
          class="onoffswitch2-checkbox"
          id="isActive"
          v-model="acessory.isActive"
        />
        <label class="onoffswitch2-label" for="isActive">
          <span class="onoffswitch2-inner"></span>
          <span class="onoffswitch2-switch"></span>
        </label>
      </div>
    </div>

    <div class="form-group row">
      <div class="col-sm-4 col-sm-offset-2">
        <LoaderButton @click="onClick">
          {{ $t("save") }}
        </LoaderButton>
      </div>
    </div>
  </form>
</template>

<script>
import { mapState, mapActions } from "vuex";
import LoaderButton from "@/components/button/LoaderButton";

export default {
  name: "AcessoryForm",

  components: {
    LoaderButton,
  },

  props: {
    acessory: {
      type: Object,
      default: () => ({
        name: "",
        isActive: true,
      }),
    },
  },

  computed: {
    ...mapState({
      acessories: (state) => state.acessories.all,
    }),
  },

  methods: {
    ...mapActions("acessories", ["create", "edit", "cleanState"]),

    async onClick(evtClick, doneFn) {
      const isValid = await this.$validator.validateAll();

      if (!isValid) {
        const err = new Error(this.$t("invalid_form_fields"));

        this.$store.dispatch("notify/error", err);

        return;
      }

      const { id } = this.acessory;

      const result = await id
        ? await this.edit({ id, data: this.acessory })
        : await this.create(this.acessory);

      if (result) {
        this.$router.push({ name: "listacessories" });
      }
    },
  },

  destroyed() {
    this.cleanState();
  },
};
</script>
